import {
  LayoutDashboard,
  Search,
  BookOpen,
  FileText,
  ShoppingCart,
  Activity,
  CalendarRange,
  CreditCard,
  Bot,
  Database,
  HeartPulse,
  Book,
  Settings,
  ListChecks,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface NavItem {
  title: string
  url: string
  icon: LucideIcon
}

export const userNavItems: NavItem[] = [
  { title: 'Dashboard', url: '/dashboard', icon: LayoutDashboard },
  { title: 'Discover', url: '/discover', icon: Search },
  { title: 'My Recipes', url: '/my-recipes', icon: BookOpen },
  { title: 'Plans', url: '/plans', icon: FileText },
  { title: 'Shopping', url: '/shopping-list', icon: ShoppingCart },
]

export const adminNavItems: NavItem[] = [
  { title: 'Overview', url: '/admin/overview', icon: LayoutDashboard },
  { title: 'Usage', url: '/admin/usage', icon: Activity },
  { title: 'Plans', url: '/admin/plans', icon: CalendarRange },
  { title: 'Billing', url: '/admin/billing', icon: CreditCard },
  { title: 'AI', url: '/admin/ai', icon: Bot },
  { title: 'Ingredient Units', url: '/admin/ingredient-units', icon: Database },
  { title: 'System Health', url: '/admin/system-health', icon: HeartPulse },
  { title: 'API Docs', url: '/admin/api-docs', icon: Book },
  { title: 'System', url: '/admin/system', icon: Settings },
  { title: 'Events', url: '/admin/events', icon: ListChecks },
]
